import { reactive, toRefs } from 'vue'
import type {
   DropShipSetting,
   LocationGroup,
   LocationMethod,
   PriceInfo,
   ProductData,
   DefaultArtworkFile,
   ProductSpec,
   SpecGroup,
   AddonGroup
} from '../types'


// 先从JSON数据里加载用户信息
const initiailize = () => {
  const productData: ProductData = (window as any).productData
  const defaultArtworkFile: DefaultArtworkFile | null = (window as any).defaultArtworkFile
  const productSpecList = productData.ProductSpecList as ProductSpec[]
  const specList = productData.SpecList as SpecGroup[]
  const addonList = productData.AddonList as AddonGroup[]
  const priceList = productData.PriceList as PriceInfo[]
  const dropShipSetting = productData.DropShipsettings as DropShipSetting
  const locationGroupList = productData.ImprintMedthodList as LocationGroup[]
  // 是否支持DropShip
  const supportDropShip = productData.Product.SupportDropShip
  // 商品编号
  const productId = productData.Product.id
  // 商品名称
  const productName = productData.Product.Name
  // 商品分类
  const productCategory = productData.Product.productCategory
  // 是否为多Size商品
  const isMultiSize = productData.Product.IsMultiSize
  // 支持的assorted 颜色数量，就是用户最多可以选几个颜色
  const assortedMaxColors = productData.Product.AssortedMaxColors
  // 是否为多Size商品
  const assortedMinQtyPerColor = productData.Product.AssortedMinQtyPerColor
  // 是否为多Size商品
  const assortedMultipleSoldQtyPerColor =
    productData.Product.AssortedMultipleSoldQtyPerColor
  // 是否为多Size商品
  const blankProductionTime = productData.Product.BlankProductionTime
  // 是否为多Size商品
  const multipleSoldQty = productData.Product.MultipleSoldQty
  // PMS颜色列表
  const pmsColorList = productData.PMSColorList
  // Imprint Method跟Mapped method的Map对象
  const imprintMethodMap: Map<string, string> = new Map()
  const requiredLocation = productData.Product.RequiredLocation
  locationGroupList.forEach((f) => {
    f.Methods.forEach((m: LocationMethod) => {
      m.artworkType = 1
      m.isPersonalizationSelected = false
      m.selectedColors = []
      m.selectedStandardColors = []
      m.selectedPmsColors = []
      m.customerNotes = ''
      m.shareLink = ''
      m.virtualDesignArts = []
      m.virtualDesignFonts = []
      m.virtualDesignJson = ''
      m.virtualDesignLogo = []
      m.selectedArtworkFiles = []
      m.isVirtualDesign = false
      m.sameColorError = false
      if (productData.Product.ProductVirtualDesign[f.Name]){
        m.supportVirtualDesign = productData.Product.ProductVirtualDesign[f.Name].includes(m.Size)
      }else{
        m.supportVirtualDesign = false
      }

      m.isVirtualDesign = !!m.supportVirtualDesign

      if (!imprintMethodMap.has(m.Method)) {
        imprintMethodMap.set(m.Method, m.MappedMethod)
      }
    })
  })

  return reactive({
    productId,
    productName,
    productCategory,
    priceList,
    productSpecList,
    specList,
    addonList,
    locationGroupList,
    dropShipSetting,
    supportDropShip,
    isMultiSize,
    blankProductionTime,
    assortedMaxColors,
    assortedMinQtyPerColor,
    assortedMultipleSoldQtyPerColor,
    multipleSoldQty,
    pmsColorList,
    imprintMethodMap,
    requiredLocation,
    defaultArtworkFile
  })
}
// let isInited = false;
const data = initiailize()
export const useWindow = () => {
  // if (isInited === false) {
  //   initiailize();
  //   isInited = true;
  // }

  return data
}

export const useGlobal = () => {
  const sessionGuid = (window as any).sessionGuid
  const countryCode = (window as any).countryCode
  const pageInfo = (window as any).pageInfo

  const {
    refer,
    priceSysNo,
    productId,
    queryQuantity,
    defaultMethod,
    priceName,
    option,
    func,
    superrush,
    isApparelCate,
    pageStyle
  } = pageInfo
  return {
    sessionGuid,
    countryCode,
    refer,
    priceSysNo,
    productId,
    queryQuantity,
    defaultMethod,
    isApparelCate,
    priceName,
    option,
    funcCallback:func,
    superrush,
    pageStyle
  }
}
